export default "__VITE_ASSET__C6Ve1GeC__"